// Runtime config. When SUPABASE_URL and SUPABASE_ANON_KEY are both set,
// the app uses real Supabase for auth + track CRUD. Otherwise it runs
// in demo mode: a permanent "Demo User" session, and the tracks list
// reads tracks/manifest.json to discover .track.json files in tracks/.
//
// To wire up Supabase: create a project at supabase.com, run the SQL
// migrations (TODO doc), and paste the project URL + anon key here.
// Both values are public — the anon key is intended to be exposed to
// the browser; database access is gated by row-level security policies.

export const SUPABASE_URL = null;
export const SUPABASE_ANON_KEY = null;

export const isConfigured = () => SUPABASE_URL != null && SUPABASE_ANON_KEY != null;
